import React from 'react';

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Footer } from '@shorelight/ui-common-components';
import { createStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

const styles = () =>
  createStyles({
    container: {
      paddingBottom: 16
    },
    topBar: {
      backgroundColor: '#ffffff',
      height: 100
    }
  });

const footerCustomStyling = {
  footerLink: {
    color: '#DC6D2B',
    '&:visited': {
      color: '#DC6D2B'
    }
  }
};

interface PageContentProps extends WithStyles<typeof styles> {
  children: React.ReactElement;
}
const PageContent = (props: PageContentProps) => {
  return (
    <Grid container className={props.classes.container}>
      <Grid item xs={12}>
        {props.children}
      </Grid>
      <Footer center={true} customStyles={footerCustomStyling} />
    </Grid>
  );
};

export default withStyles(styles)(PageContent);
